<div ngbDropdown
     autoClose="outside"
     container="auto"
     placement="bottom-right">
  <mbs-button class="mbs-rm-button -no-arrow"
              container="body"
              (click)="editColumnButtonClick.emit(true)"
              [active]="existHiddenColumns"
              [attr.data-test-element]="elementsSelector.name.showColumnsButton"
              [attr.data-posthog-action]="'Visible columns button click'"
              [icon]="'fa fa-columns'"
              [ngbTooltip]="'mbs-ui-kit:adjustTableColumns.editColumns' | i18next"
              ngbDropdownToggle>
                <span *ngIf="isDotShown()"
                      [attr.data-test-element]="elementsSelector.name.hasUpdateDot"
                      class="mbs-adjust-table-columns_dot"></span>
  </mbs-button>

  <div ngbDropdownMenu
       aria-labelledby="columnsShowList">
    <mbs-checkbox *ngFor="let name of currentColumnNames"
                  ngbDropdownItem
                  [disabledSelf]="isCheckboxReadonly"
                  (change)="columnForShowChanged.emit({ checked: $event, name })"
                  [(ngModel)]="columnsForShow[name].show"
                  [attr.data-test-element]="elementsSelector.name.showColumnCheckbox"
                  [attr.data-posthog-action]="name + ' column turn '+ (columnsForShow[name].show ? 'Off' : 'On')"
                  [attr.data-posthog-category]="'Visible columns list change'"
                  [label]="columnsForShow[name].label"></mbs-checkbox>
  </div>
</div>
